<header class="notification-panel-header">
  <div class="notification-panel-header-content">
    <div class="notification-panel-header__title">
      <h2>{{ "Notifications" | translate }}</h2>
      <span *ngIf="unreadCount > 0" class="notification-panel-header__count">
        {{ unreadCountLabel }}
      </span>
    </div>
    <a (click)="dismissAll.emit(); $event.stopPropagation()" class="dismissAllLink">
      {{ "Set all as readed" | translate }}
    </a>
  </div>
  <div class="notification-panel-filter-wrap" (click)="$event.stopPropagation()">
    <div class="notification-panel-filter">
      <button
        type="button"
        class="notification-panel-filter__option"
        [class.notification-panel-filter__option--active]="!onlyUnread"
        (click)="onFilterClick('all')"
      >
        {{ "All" | translate }}
      </button>
      <button
        type="button"
        class="notification-panel-filter__option"
        [class.notification-panel-filter__option--active]="onlyUnread"
        (click)="onFilterClick('unreaded')"
      >
        {{ "Unread" | translate }}
        <span *ngIf="unreadCount > 0" class="notification-panel-filter__count">{{ unreadCount }}</span>
      </button>
    </div>
  </div>
</header>
<mat-divider></mat-divider>
<div class="notification-panel-list" (scroll)="onListScroll($event)">
  <button
    *ngFor="let notification of visibleNotifications"
    (click)="onNotificationClick(notification)"
    mat-menu-item
    class="notification-list-item"
    [class.notification-list-item--unread]="isUnread(notification)"
    [wsTooltip]="tooltipTimestamp(notification)"
  >
    <span
      class="notification-list-item__bar"
      [style.background-color]="barColor(notification)"
    ></span>
    <span
      class="notification-list-item__icon"
      [style.background-color]="iconTone(notification).iconBackground"
      [style.color]="iconTone(notification).iconColor"
    >
      <mat-icon>{{ iconTone(notification).matIcon }}</mat-icon>
    </span>
    <div class="notification-list-item__content">
      <div class="notification-list-item__header">
        <strong class="notification-list-item__title">{{ titleFor(notification) }}</strong>
        <ws-chip
          *ngIf="isUnread(notification)"
          class="notification-list-item__new"
          [type]="newChipType"
          [label]="'NEW' | translate"
        ></ws-chip>
      </div>
      <span class="notification-list-item__body">{{ bodyFor(notification) }}</span>
      <div
        *ngIf="hasMarkerRow(notification); else timeOnly"
        class="notification-list-item__meta"
      >
        <div class="notification-list-item__chips">
          <ws-chip
            *ngIf="showInvoiceChip(notification)"
            class="notification-list-item__chip notification-list-item__chip--invoice"
            [color]="invoiceChipColor"
            [backgroundColor]="invoiceChipBackground"
            [label]="'Invoice requested' | translate"
          >
            <mat-icon>description</mat-icon>
          </ws-chip>
          <ws-chip
            *ngIf="showShippingChip(notification)"
            class="notification-list-item__chip notification-list-item__chip--shipping"
            [color]="shippingChipColor"
            [backgroundColor]="shippingChipBackground"
            [label]="'Shipping requested' | translate"
          >
            <mat-icon>local_shipping</mat-icon>
          </ws-chip>
        </div>
        <span class="notification-list-item__time">
          {{ listTimestamp(notification) }}
        </span>
      </div>
      <ng-template #timeOnly>
        <span class="notification-list-item__time">
          {{ listTimestamp(notification) }}
        </span>
      </ng-template>
    </div>
  </button>
  <p *ngIf="visibleNotifications.length === 0 && !loading" class="notification-panel-empty">
    {{ "No notifications here yet." | translate }}
  </p>
  <p *ngIf="loading" class="notification-panel-loading">
    {{ "Loading..." | translate }}
  </p>
</div>
